






import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
    name: 'ui-group-validator'
})

export default class ControlValidatorGroupComponent extends Vue {   
    isValidChilds(vue: Vue, isValid: boolean): boolean {        
        vue.$children.forEach(element => {
            if((element as any).isValid){
                var validate = (element as any).isValid();                    
                isValid = isValid && validate;
            } else if ((element as Vue).$children.length > 0) {
                isValid = this.isValidChilds(element, isValid);
            }
        });
        return isValid;
    }
    isValid(): boolean {
        return this.isValidChilds(this as Vue, true);
    }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-group-validator/src/ui-group-validator.vue